/** @format */

import { capitalize, get, parseInt } from 'lodash';
import PropTypes from 'prop-types';
import { createContext, useCallback, useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { useGetMeQuery, useLogoutMutation } from 'src/api/account-api';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import { selectRevokeAccount } from 'src/store/app-slice';
import { Issuer } from 'src/utils/auth';
import { getKeyPush } from 'src/utils/local-storage';

var ActionType;
(function (ActionType) {
  ActionType['AUTH_STATE_CHANGED'] = 'AUTH_STATE_CHANGED';
})(ActionType || (ActionType = {}));

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const reducer = (state, action) => {
  if (action.type === 'AUTH_STATE_CHANGED') {
    const { isAuthenticated, user } = action.payload;

    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  }

  return state;
};

export const AuthContext = createContext({
  ...initialState,
  issuer: Issuer.Firebase,

  signInWithEmailAndPassword: () => Promise.resolve(),
  signInWithGoogle: () => Promise.resolve(),
  signOut: () => Promise.resolve()
});

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const router = useRouter();

  const revokeAccount = useSelector(selectRevokeAccount);

  const [logout] = useLogoutMutation();

  const { data: user, isSuccess, error } = useGetMeQuery();

  const handleAuthStateChanged = useCallback(
    async (user) => {
      // const { data: user, error } = await getMe();

      if (user) {
        const keyPush = getKeyPush();

        const permissions = get(user, 'permissions', []);
        const role = parseInt(user.role);
        const setupCompleted = get(user, 'setupCompleted', true);
        const zPermissionRequire = get(user, 'zPermissionRequire', false);
        // console.log('handleAuthStateChanged user', {
        //   id: user.id,
        //   role,
        //   setupCompleted,
        //   //   isAcceptResetPassword,
        //   zPermissionRequire,

        //   permissions,
        //   keyPush: keyPush,
        //   avatar: user.photoURL || undefined,
        //   email: user.email,
        //   displayName: capitalize(user.displayName),
        //   phoneNumber: user.phoneNumber,
        //   addess: user.addess
        // });
        dispatch({
          type: ActionType.AUTH_STATE_CHANGED,
          payload: {
            isAuthenticated: true,
            user: {
              id: user.id,
              role,
              setupCompleted,
              // isAcceptResetPassword,
              zPermissionRequire,

              permissions,
              keyPush: keyPush,
              avatar: user.photoURL || undefined,
              email: user.email,
              displayName: capitalize(user.displayName),
              phoneNumber: user.phoneNumber,
              addess: user.addess
            }
          }
        });
      } else {
        console.log('onAuthStateChanged out');
        dispatch({
          type: ActionType.AUTH_STATE_CHANGED,
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (error?.status === 401) {
      handleAuthStateChanged();
      const searchParams = new URLSearchParams({
        returnTo: window.location.href
      }).toString();
      const href = paths.auth.login + `?${searchParams}`;
      router.push(href);
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess) {
      handleAuthStateChanged(user);
    }
  }, [user, isSuccess]);

  useEffect(() => {
    if (state.isInitialized && revokeAccount) {
      _signOut();
    }
  }, [revokeAccount]);

  const _signOut = useCallback(async () => {
    await logout();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        issuer: Issuer.Firebase,

        signOut: _signOut
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const AuthConsumer = AuthContext.Consumer;
